import { render } from "./LiveProScreen.vue?vue&type=template&id=50059746&scoped=true&ts=true&lang=pug"
import script from "./LiveProScreen.vue?vue&type=script&lang=ts"
export * from "./LiveProScreen.vue?vue&type=script&lang=ts"

import "./LiveProScreen.vue?vue&type=style&index=0&id=50059746&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50059746"]])

export default __exports__